import FeatureGates from '@atlaskit/feature-gate-js-client';

export const isRovoTtaiSegmentRenderStabilizationEnabled = (): boolean =>
	FeatureGates.getExperimentValue<boolean>(
		'rovo_ttai_segment_render_stabilization',
		'isEnabled',
		false,
	) === true;
